<form #myHelpForm (ngSubmit)="onSubmit()" [formGroup]="helpForm">
    <div class="container">
        <div class="form-group m-5">
            <h4 for="type" class="required highlightText">Please select option</h4>
            <div class="row">
                <div class="col-sm-6">
                    <input type="radio" #type1 id="type1" formControlName="type" (change)="onDropDownChange()" required="true" name="type" value="issue" [checked]="true" >
                    <label class="ml-3 labelText" for="type">Issue</label><br>
                </div>
                <div class="col-sm-6">
                    <input type="radio" #type2 id="type2" formControlName="type" (change)="onDropDownChange()" required="true" name="type" value="suggestion">
                    <label class="ml-3 labelText" for="type">Suggestion</label><br>
                </div>
            </div>
        </div>

        

        <!-- <div class="form-group m-5">
            <h4 for="type" >Please select option</h4>
            <select name="type" class="textbox-inside" #type formControlName="type" id="type" (change)="onDropDownChange()" required="true">
                <option value="issue">Issue</option>
                <option value="suggestion">Suggestion</option>
            </select>
        </div> -->

        <div *ngIf="isIssueSelected" class="form-group m-5">
            <h4 for="type" class="required highlightText">What is the frequency of issue</h4>
            <div class="row">
                <div class="col-sm-6">
                    <input type="radio" #issuefrequency1 id="issuefrequency1" formControlName="issuefrequency" (change)="onDropDownChange()" required="true" name="issuefrequency" value="intermittent" >
                    <label class="ml-3 labelText" for="type">Intermittent</label><br>
                </div>
                <div class="col-sm-6">
                    <input type="radio" #issuefrequency2 id="issuefrequency2" formControlName="issuefrequency" (change)="onDropDownChange()" required="true" name="issuefrequency" value="recurring">
                    <label class="ml-3 labelText" for="type">Recurring</label><br>
                </div>
            </div>
        </div>

        <!-- <div *ngIf="isIssueSelected" class="form-group m-5">
            <h4 for="issuefrequency">What is the frequency of issue</h4>

            <select name="issuefrequency" id="issuefrequency" #frequency formControlName="frequency" class="textbox-inside">
                <option value="intermittent">Intermittent</option>
                <option value="recurring">Recurring</option>
            </select>
        </div> -->

        <div class="form-group m-5 p-0">
            <h4 for="description" class="required highlightText">Please share detailed description</h4>
            <textarea type="text" id="description" name="description" #description formControlName="description" required="true"></textarea>
        </div>
        
        <div class="btn-submit m-5" align="center">
            <button type="submit" class="ct-btn primary-btn" [disabled]="!isHelpFormValid()">Submit Details</button>
        </div>
    </div>
</form>